// TODO: after resize it's always false - issue
// Define calibration line direction
export const isVertical = (x1: number, x2: number) => {
    return Math.round(x1) === Math.round(x2)
}
